// import { setDate } from "./setDate";


// export const stripHtmlAndExtractColor = (html) => {
//   if (typeof html !== 'string') {
//     if (typeof html === 'number') {
//       html = String(html);
//     } else if (typeof html === 'object') {
//       if (html?.date) {
//         html = String(setDate(html.date));
//       } else {
//         html = ""; 
//       }
//     } else {
//       return {
//         text: '',
//         color: null,
//         bold: false,
//         backgroundColor: null,
//         margin: null,
//         padding: null,
//         textAlign: null,
//       };
//     }
//   }

//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;

//   const colorMatch = html.match(/<font[^>]*color=["']?(#[0-9A-F]{3,6}|[a-zA-Z]+)["']?[^>]*>/i) ||
//     html.match(/style=["'][^"']*color:\s*(#[0-9A-F]{3,6}|[a-zA-Z]+)[^"']*["']/i);

//   const backgroundColorMatch = html.match(/style=["'][^"']*background-color:\s*(#[0-9A-F]{3,6}|[a-zA-Z]+)[^"']*["']/i);
//   const marginMatch = html.match(/margin:\s*([^;]*)/i);
//   const paddingMatch = html.match(/padding:\s*([^;]*)/i);
//   const textAlignMatch = html.match(/text-align:\s*([^;]*)/i);
//   const isBold = html.includes("<b>") || html.includes("<strong>");


//   const allowedTags = ['b', 'br', 'i', 'u', 'font', 'strong', 'span'];
//   const cleanedHtml = tempDiv.innerHTML.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (match, tag) => {
//     return allowedTags.includes(tag.toLowerCase()) ? match : '';
//   });

//   return {
//     text: cleanedHtml.trim(), 
//     color: colorMatch ? colorMatch[1] : null,
//     bold: isBold,
//     backgroundColor: backgroundColorMatch ? backgroundColorMatch[1] : null,
//     margin: marginMatch ? marginMatch[1].trim() : null,
//     padding: paddingMatch ? paddingMatch[1].trim() : null,
//     textAlign: textAlignMatch ? textAlignMatch[1].trim() : null,
//   };
// };


// // import { setDate } from "./setDate";

// // export const stripHtmlAndExtractColor = (html) => {
// //   if (typeof html !== 'string') {
// //     if (typeof html === 'number') {
// //       html = String(html);
// //     } else if (typeof html === 'object') {
// //       if (html?.date) {
// //         html = String(setDate(html.date));
// //       } else {
// //         html = ""; 
// //       }
// //     } else {
// //       return {
// //         text: '',
// //         color: null,
// //         bold: false,
// //         backgroundColor: null,
// //         margin: null,
// //         padding: null,
// //         textAlign: null,
// //       };
// //     }
// //   }

// //   const tempDiv = document.createElement("div");
// //   tempDiv.innerHTML = html;

// //   const colorMatch = html.match(/<font color=["']?(#[0-9A-F]{6}|#[0-9A-F]{3})["']?>(.*?)<\/font>/i) ||
// //     html.match(/style=["'].*?(?<!background-)color:\s*(#[0-9A-F]{6}|#[0-9A-F]{3}).*?["']/i);
// //   const backgroundColorMatch = html.match(/style=["'].*?background-color:\s*(#[0-9A-F]{6}|#[0-9A-F]{3}).*?["']/i);
// //   const marginMatch = html.match(/margin:\s*([^;]*)/i);
// //   const paddingMatch = html.match(/padding:\s*([^;]*)/i);
// //   const textAlignMatch = html.match(/text-align:\s*([^;]*)/i);
// //   const isBold = html.includes("<b>") || html.includes("<strong>");

// //   const text = tempDiv.innerHTML
// //     .replace(/<br\s*\/?>/gi, '\n')           
// //     .replace(/<\/?[^>]+(>|$)/g, '')          
// //     .trim();

// //   return {
// //     text,
// //     color: colorMatch ? colorMatch[1] : null,
// //     bold: isBold,
// //     backgroundColor: backgroundColorMatch ? backgroundColorMatch[1] : null,
// //     margin: marginMatch ? marginMatch[1].trim() : null,
// //     padding: paddingMatch ? paddingMatch[1].trim() : null,
// //     textAlign: textAlignMatch ? textAlignMatch[1].trim() : null,
// //   };
// // };

import { setDate } from "./setDate";

export const stripHtmlAndExtractColor = (html) => {
    if (typeof html !== 'string') {
        console.log(html, "data");
        console.log(typeof(html), "typeof");
        if (typeof html === 'number') {
            html = String(html);
        } else if (typeof html === 'object' && html !== null) {
          console.log(html,"html")
          
            html = String(setDate( html?.date));
        } else {
            return {
                text: '',
                color: null,
                bold: false,
                backgroundColor: null,
                margin: null,
                padding: null,
                textAlign: null,
            };
        }
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;


    const colorMatch = html.match(/<font color=["']?(#[0-9A-F]{6}|#[0-9A-F]{3})["']?>(.*?)<\/font>/i) ||
                       html.match(/style=["'].*?(?<!background-)color:\s*(#[0-9A-F]{6}|#[0-9A-F]{3}).*?["']/i);

    const backgroundColorMatch = html.match(/style=["'].*?background-color:\s*(#[0-9A-F]{6}|#[0-9A-F]{3}).*?["']/i);
    const marginMatch = html.match(/margin:\s*([^;]*)/i);
    const paddingMatch = html.match(/padding:\s*([^;]*)/i);
    const textAlignMatch = html.match(/text-align:\s*([^;]*)/i);
    const isBold = html.includes("<b>") || html.includes("<strong>")
    const fontSizeMatch = html.match(/font-size:\s*([^;]*)/i);
    
    return {
        text: tempDiv.innerText.trim() || "",
        color: colorMatch ? colorMatch[1] : null,
        bold: isBold,
        backgroundColor: backgroundColorMatch ? backgroundColorMatch[1] : null,
        margin: marginMatch ? marginMatch[1].trim() : null, 
        padding: paddingMatch ? paddingMatch[1].trim() : null, 
        textAlign: textAlignMatch ? textAlignMatch[1].trim() : null, 
        fontSize : fontSizeMatch ? fontSizeMatch[1].trim() : null
    };
};
